import { render, staticRenderFns } from "./KInputText.vue?vue&type=template&id=4eafbbc8&scoped=true&lang=html&"
import script from "./KInputText.vue?vue&type=script&lang=ts&"
export * from "./KInputText.vue?vue&type=script&lang=ts&"
import style0 from "./KInputText.vue?vue&type=style&index=0&id=4eafbbc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eafbbc8",
  null
  
)

export default component.exports